import React from "react";
import Grid from '@material-ui/core/Grid';
import Typography from "@material-ui/core/Typography";
import Helpers from "../Utils/Helpers.js";
import Hidden from '@material-ui/core/Hidden';
import {Settings} from '../Utils/Settings.js';
import { Link } from "react-router-dom";

import SearchResultThumbnail from './SearchResultThumbnail.js';
import SearchResultsHighlight from './SearchResultHighlight.js';

function SearchResultRow(elementProps) {

    const {element, index, inventoryType, classes} = elementProps;

    let description = element.description.replace(/<[^>]*>/g, "");
    let descriptionTrimmed = Helpers.trimAtNextWhitespace(description, 300);
    let basePath = "";
    if (inventoryType === Settings.inventoryTypes.TRAILER) {
        basePath = "/trailer"
    } else if (inventoryType === Settings.inventoryTypes.CARGO) {
        basePath = "/cargo"
    } else if (inventoryType === Settings.inventoryTypes.PART) {
        basePath = "/part"
    } else if (inventoryType === Settings.inventoryTypes.TRUCK) {
        basePath = "/truck"
    } else if (inventoryType === Settings.inventoryTypes.INVENTORY) {
        basePath = "/listing"
    }

    const inventoryLink = basePath + "/details/" + element.id + "/" + Helpers.getSeoFriendlyName(element.title);

    return(
        <React.Fragment>
            <Grid key={index+"col1"} item xl={2} lg={3} md={3} sm={4} xs={12}>
                <Link to={inventoryLink}><SearchResultThumbnail image={element.thumbnail} caption={element.caption} /></Link>
            </Grid>
            <Grid key={index+"col2"} item xl={7} lg={6} md={6} sm={4} xs={12}>
                <Link className={classes.resultLink} to={inventoryLink}><Typography variant='h5'>{element.title}</Typography></Link>
                <Typography variant='body1' dangerouslySetInnerHTML={{__html: descriptionTrimmed}}></Typography>
            </Grid>
            <Grid key={index+"col3"} item xl={3} lg={3} md={3} sm={4} xs={12}>
                <SearchResultsHighlight key={index+"col4"} element={element} inventoryLink={inventoryLink}></SearchResultsHighlight>
                <Hidden smUp><hr/></Hidden>
            </Grid>
        </React.Fragment>
    )
}

export default (SearchResultRow);